@let fieldData = field();

<div class="mb-6 x-text-dark-main">
  @if (fieldData.title) {
    <label
      class="block x-font-body-3 mb-2"
      [class.font-extrabold!]="fieldData.isHighlighted"
    >
      {{ fieldData.title }}
      @if (fieldData.helpText) {
        <tui-icon [tuiTooltip]="fieldData.helpText"></tui-icon>
      }
    </label>
  }

  <p
    class="x-font-body-4 whitespace-pre-line x-text-wf-title"
    [class.font-extrabold!]="fieldData.isHighlighted"
    [innerHtml]="fieldData.text"
  ></p>
</div>
